export default __webpack_public_path__ + "static/media/AFTIM-img-4.4baba8b7.jpg";